import { LoaderIcon } from 'assets/svg';
import styled, { css } from 'styled-components';

const Wrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'innerLoader',
})<{ innerLoader?: boolean }>`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  flex: 1;
  gap: 17px;

  color: #1C1C1C;
  font-size: 34px;
  font-weight: 500;
  line-height: 48px;

  ${({ innerLoader }) =>
    innerLoader &&
    css`
      align-self: flex-start;
      position: relative;
      height: auto;
      flex: 0;
    `};
`;

const Loader = styled(LoaderIcon)`
  display: block;
  margin: 0;
  transform: rotate(0);
  animation: rotateCircle 2s infinite linear;

  @keyframes rotateCircle {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default { Wrapper, Loader };
